<figure class="figure">
  <img
    mat-card-image
    [media]="item.image.data"
    [format]="'large'"
    class="image"
  />
</figure>
